module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "profileView"
    }
  }, [(_vm.isLoading) ? _c('mu-content-block', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('mu-circular-progress', {
    attrs: {
      "size": 32
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    domProps: {
      "textContent": _vm._s(_vm.$t('message.loadingText'))
    }
  })], 1) : _vm._e(), _vm._v(" "), (!_vm.$route.meta.isChild && !_vm.isLoading) ? _c('div', [(_vm.profile.user_id) ? _c('profile-header', {
    staticClass: "insetGraph",
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    attrs: {
      "id": "scroll-detector"
    }
  }), _vm._v(" "), _c('mu-paper', {
    staticClass: "insetTabBar innerProfile",
    class: {
      isDocked: _vm.avatarDocked
    },
    attrs: {
      "id": "profileTabs"
    }
  }, [_c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticStyle: {
      "position": "relative"
    },
    attrs: {
      "desktop": "25",
      "tablet": "30",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.avatarDocked === false),
      expression: "avatarDocked === false"
    }],
    staticClass: "relativeAvatar desktop",
    attrs: {
      "size": 190,
      "src": _vm.profile.profile_image
    }
  }), _vm._v(" "), _c('mu-flexbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.avatarDocked === true),
      expression: "avatarDocked === true"
    }],
    staticStyle: {
      "height": "52px"
    },
    attrs: {
      "align": "center",
      "justify": "center"
    }
  }, [_c('mu-flexbox-item', {
    attrs: {
      "shrink": "9",
      "grow": "1",
      "align": "center"
    }
  }, [_c('mu-avatar', {
    staticClass: "desktop",
    staticStyle: {
      "position": "relative",
      "top": "4px"
    },
    attrs: {
      "size": 34,
      "src": _vm.profile.profile_image
    }
  })], 1), _vm._v(" "), _c('mu-flexbox-item', {
    attrs: {
      "grow": "3"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.profile.display_name))])])], 1)], 1), _vm._v(" "), _c('mu-col', {
    attrs: {
      "desktop": "75",
      "tablet": "70"
    }
  }, [_c('ul', _vm._l((_vm.routes), function(route) {
    return (_vm.hideTabItems(route.name)) ? _c('li', {
      class: {
        active: route.name === _vm.$route.name
      }
    }, [_c('a', {
      domProps: {
        "textContent": _vm._s(route.label)
      },
      on: {
        "click": function($event) {
          return _vm.goTo(route.name)
        }
      }
    })]) : _vm._e()
  }), 0)])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "innerProfile",
    class: {
      isDocked: _vm.avatarDocked
    }
  }, [(!_vm.$route.meta.isChild && _vm.profile) ? _c('router-view', {
    staticClass: "routerView mobile",
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e(), _vm._v(" "), _c('mu-row', {
    staticClass: "padRow",
    attrs: {
      "gutter": ""
    }
  }, [_c('mu-col', {
    staticClass: "profileAvatar",
    attrs: {
      "width": "100",
      "desktop": "25",
      "tablet": "30"
    }
  }, [(!_vm.isLoading) ? _c('profile-avatar', {
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.profile) ? _c('mu-col', {
    staticClass: "routerView desktop",
    attrs: {
      "width": "100",
      "desktop": "75",
      "tablet": "70"
    }
  }, [(!_vm.$route.meta.isChild) ? _c('router-view', {
    attrs: {
      "profile": _vm.profile
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acd8d42a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Profile/Profile.vue
// module id = 3828
// module chunks = 1